<template>
  <div :id="'mode-autocomplete' + tripNumber" class="mode">
    <label :for="'mode' + tripNumber">Mode: </label>
    <AutoComplete
      :id="'mode' + tripNumber"
      v-model="selectedMode"
      :suggestions="filteredModes"
      field="name"
      @complete="searchSuggestions($event)"
      :dropdown="true"
      :title="selectedMode ? selectedMode.name : 'Not selected Mode'"
      @item-select="updateMode()"
      style="width: 70%"
    />
    <br />
  </div>
</template>

<script>
import AutoComplete from "primevue/autocomplete";
import { removePointerEvents } from "@/mixins/pickupAndDelivery/standardizers";
import { mapGetters } from "vuex";

export default {
  name: "Mode",
  props: {
    tripNumber: Number,
    getModes: Promise,
    actualQueue: String
  },
  components: {
    AutoComplete
  },
  data() {
    return {
      currentDepartment: null,
      selectedMode: null,
      allModes: null,
      filteredModes: null,
      haulInformation: null,
      newTab: null,
      allowed: true,
      user: null,
      item: null,
      assignedUser: null,
      disableEmailResponse: true
    };
  },
  computed: {
    ...mapGetters("login", ["showInfoDepartment"])
  },
  watch: {
    selectedMode() {
      if (this.allModes) {
        this.$emit("stopSpinner");
        this.$store.commit("quotes/quote/setSelectedMode", this.selectedMode);
        return this.allModes?.name;
      }
    },
    async showInfoDepartment(value) {
      this.currentDepartment = value;
    }
  },
  async created() {
    this.currentDepartment = this.showInfoDepartment;
    this.haulInformation = this.$store.getters[
      "quotes/quote/showQuoteById"
    ].haul;
    await this.getAllModes();
  },
  mounted() {
    let userAux = localStorage.getItem("charlie-username-otr");
    this.user = JSON.parse(userAux);
    this.handlerMode();
  },
  methods: {
    handlerMode() {
      this.item = this.$store.getters["quotes/quote/showQuoteById"];
      this.assignedUser =
        this.item.message.user == null ? null : this.item.message.user.username;
      if (
        (this.currentDepartment.department_id == 1 &&
          this.currentDepartment.rol_name == "superuser" &&
          this.assignedUser == null) ||
        this.user[0].user.username == this.assignedUser
      ) {
        this.disableEmailResponse = false;
      }
      let allowedRoutes = ["myQueue", "failed", "queue", "alerts"];
      if (!allowedRoutes.includes(this.$route.params.pathName)) {
        this.allowed = false;
      }
      if (this.allowed) {
        if (
          (this.currentDepartment.rol_name == "quoter" &&
            this.$route.params.pathName == "queue") ||
          this.disableEmailResponse ||
          this.item.message.validation_alert
        ) {
          removePointerEvents("mode-autocomplete" + this.tripNumber);
        }
      } else {
        removePointerEvents("mode-autocomplete" + this.tripNumber);
      }
    },
    searchSuggestions(event) {
      setTimeout(() => {
        this.filteredModes = this.allModes.filter(mode => {
          return mode?.name.toLowerCase().startsWith(event.query.toLowerCase());
        });
      }, 250);
    },
    updateMode() {
      let info = {};
      info.haulId = this.haulInformation[this.tripNumber - 1].id;
      info.payload = {};
      info.payload.tms_mode = {};
      info.payload.tms_mode.id = this.selectedMode.id;
      info.payload.tms_mode.name = this.selectedMode?.name;
      this.$store.dispatch("quotes/haul/updateHaul", info);
    },
    async getAllModes() {
      let modesAll = await this.getModes;
      this.allModes = modesAll.data;
      if (this.haulInformation[this.tripNumber - 1]?.tms_mode?.name === null) {
        this.allModes.forEach(element => {
          if (this.currentDepartment == 1) {
            if (element.name === "LTL") {
              this.selectedMode = element;
              this.updateMode();
            }
          } else {
            this.selectedMode = null;
          }
        });
      } else {
        this.selectedMode = this.haulInformation[this.tripNumber - 1].tms_mode;
      }
      this.$store.commit("quotes/quote/setSelectedMode", this.selectedMode);
      this.$emit("stopSpinner");
    }
  }
};
</script>

<style lang="scss" scoped>
.mode {
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  label {
    margin: 0;
    margin-right: 15px;
  }
}

::v-deep .p-inputtext {
  width: 180px;
  height: 29px;
  padding: 3px 10px;
  background: $color-background-input;
  font-size: 14px;
  &:hover {
    @include box-shadow;
    border-color: get-opacity($color-gray-shadow, 30%) !important;
  }
  &:focus {
    border-color: get-opacity($color-gray-shadow, 80%) !important;
    box-shadow: 0 0 0 0.2rem get-opacity($color-gray-shadow, 40%) !important;
  }
}

::v-deep .p-autocomplete-panel {
  width: 242px;
}

::v-deep .p-autocomplete-panel .p-autocomplete-items .p-autocomplete-item {
  text-align: left;
  font-size: 14px;
}

::v-deep .p-button {
  border: $color-primary-button;
}

::v-deep .p-button.p-button-icon-only {
  @include primary-button;
  box-shadow: none;
  width: 29px;
  height: 29px;
}

@media (max-width: 604px) {
  .mode {
    margin-top: 28px;
  }
}
</style>
